export const envVars = Object.freeze({
  actionCableUrl: process.env.NEXT_PUBLIC_ACTION_CABLE_URL,
  appApiUrl: process.env.NEXT_PUBLIC_API_BASE_URL,
  apiV2BaseUrl: process.env.NEXT_PUBLIC_API_V2_BASE_URL,
  easyStoreAppId: process.env.NEXT_PUBLIC_EASY_STORE_APP_ID,
  googleRecaptchaSiteKey: process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY,
  landingPageUrl: process.env.NEXT_PUBLIC_LANDING_PAGE_URL,
});

export const isProduction = process.env.NODE_ENV === 'production';
